module.exports = __webpack_public_path__ + "img/lesson-manage-active.006deeff.svg";